function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_61277",
  d: "M16.9,28.566a12.078,12.078,0,0,0,12.012-12,12.006,12.006,0,1,0-12.012,12ZM11.286,16.578a1.115,1.115,0,0,1,1.161-1.161h3.308V12.11a1.091,1.091,0,0,1,1.126-1.149,1.106,1.106,0,0,1,1.161,1.149v3.308H21.36a1.149,1.149,0,1,1,0,2.3H18.041v3.308a1.112,1.112,0,0,1-1.161,1.149,1.1,1.1,0,0,1-1.126-1.149V17.715H12.447A1.11,1.11,0,0,1,11.286,16.578Z",
  transform: "translate(-4.903 -4.566)"
});

function SvgFilledPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.012 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPlus);
export default __webpack_public_path__ + "static/media/filled_plus.b2604ff4.svg";
export { ForwardRef as ReactComponent };